import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useParams } from 'react-router-dom';
import {
  VaSidenav,
  VaSidenavItem,
} from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { useFeatureToggle } from '~/platform/utilities/feature-toggles/useFeatureToggle';

const ClaimantDetailsWrapper = ({ firstName, lastName, children }) => {
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const isClaimantDetailsUpdateEnabled = useToggleValue(
    TOGGLE_NAMES.accreditedRepresentativePortalCdUpdateMain,
  );
  const { pathname } = useLocation();
  const { claimantId } = useParams();
  const activeTab = pathname.split('/')[2];
  const isActive = path => (activeTab === path ? true : undefined);
  const sideNavLinks = [
    { label: 'Claimant overview', route: 'claimant-overview' },
    ...(isClaimantDetailsUpdateEnabled
      ? [{ label: 'Submit forms and files', route: 'submit-forms-and-files' }]
      : []),
    { label: 'Submission history', route: 'submission-history' },
  ];
  const buildLink = path =>
    `/representative/find-claimant/${path}/${claimantId}`;
  return (
    <div className="vads-grid-container vads-u-padding-x--0">
      <h1>
        <div className="vads-u-font-size--h2 vads-u-font-weight--normal">
          Claimant
        </div>{' '}
        {lastName}, {firstName}
      </h1>
      <hr className="vads-u-margin-y--4" aria-hidden="true" />
      <div className="vads-grid-row">
        <div className="vads-u-padding-right--2p5 vads-grid-col-12 vads-u-padding-bottom--4 medium-screen:vads-grid-col-4 desktop:vads-grid-col-4 desktop-lg:vads-grid-col-4">
          <VaSidenav
            header="Claimant"
            icon-background-color="vads-color-primary"
            icon-name="account_circle"
          >
            {sideNavLinks.map((sideNavLink, index) => (
              <VaSidenavItem
                key={index}
                href={buildLink(sideNavLink.route)}
                label={sideNavLink.label}
                currentPage={isActive(sideNavLink.route)}
              />
            ))}
          </VaSidenav>
        </div>
        <div className="medium-screen:vads-u-padding-left--2p5 vads-grid-col-12 medium-screen:vads-grid-col-8 desktop-lg:vads-grid-col-8">
          {children}
        </div>
      </div>
    </div>
  );
};

ClaimantDetailsWrapper.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default ClaimantDetailsWrapper;
